import { HttpError, SuggestedPhysicalAddress } from '@rd/types';
import {
  PhysicalAddressActions,
  PhysicalAddressActionTypes,
} from '../actions/physical-address.actions';

export interface SuggestedAddressesState {
  suggestedAddresses: SuggestedPhysicalAddress[];
  error: HttpError | null;
  loading: boolean;
}

const initialState: SuggestedAddressesState = {
  suggestedAddresses: [],
  error: null,
  loading: false,
};

export function suggestedAddressesReducer(
  state: SuggestedAddressesState = initialState,
  action: PhysicalAddressActions,
): SuggestedAddressesState {
  switch (action.type) {
    case PhysicalAddressActionTypes.LOAD_SUGGESTED_ADDRESSES:
      return {
        ...state,
        suggestedAddresses: [],
        error: null,
        loading: true,
      };

    case PhysicalAddressActionTypes.LOAD_SUGGESTED_ADDRESSES_SUCCESS:
      return {
        ...state,
        suggestedAddresses: action.payload,
        error: null,
        loading: false,
      };

    case PhysicalAddressActionTypes.LOAD_SUGGESTED_ADDRESSES_FAILED:
      return {
        ...state,
        error: action.payload,
        loading: false,
      };

    default:
      return state;
  }
}
